module.exports = __webpack_public_path__ + "img/386169_A9CFDB_153C23_7CA3AC-256px.ee8e1885.png";